// extracted by mini-css-extract-plugin
export default {"container":"Buy_container__kmGS5"};